import { useCallback, useState } from 'react';

export type FetchMoreItems = (startIndex: number, stopIndex: number) => Promise<void>;

export const useLoadMoreItems = (fetchMoreItems: FetchMoreItems) => {
    const [isItemsLoading, setIsItemsLoading] = useState(false);

    const memoizeLoadMoreItems = useCallback(
        (startIndex: number, endIndex: number) => {
            if (isItemsLoading) {
                return undefined;
            }

            setIsItemsLoading(true);

            return fetchMoreItems(startIndex, endIndex)
                .then(() => {
                    setIsItemsLoading(false);
                })
                .catch(error => {
                    setIsItemsLoading(false);
                    throw error;
                });
        },
        [isItemsLoading, fetchMoreItems]
    );

    return memoizeLoadMoreItems;
};
